import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.5 3L8 4.5L11 7.5H1V9.5H11L8 12.5L9.5 14L15 8.5L9.5 3Z",
		fill: "rgba(0, 82, 255, 1)"
	})
});
export default SvgRightArrow;
